// Lightweight relative-time formatter — used for "Last updated" badges
export function timeAgo(iso) {
  if (!iso) return null;
  try {
    const then = new Date(iso).getTime();
    if (isNaN(then)) return null;
    const seconds = Math.floor((Date.now() - then) / 1000);
    if (seconds < 60) return 'just now';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} min${minutes !== 1 ? 's' : ''} ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
    const days = Math.floor(hours / 24);
    if (days < 30) return `${days} day${days !== 1 ? 's' : ''} ago`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months} month${months !== 1 ? 's' : ''} ago`;
    const years = Math.floor(days / 365);
    return `${years} year${years !== 1 ? 's' : ''} ago`;
  } catch {
    return null;
  }
}

// Returns 'fresh' (< 7 days), 'stale' (7-30 days), 'old' (> 30 days)
export function freshness(iso) {
  if (!iso) return 'old';
  const days = (Date.now() - new Date(iso).getTime()) / (1000 * 60 * 60 * 24);
  if (days < 7) return 'fresh';
  if (days < 30) return 'stale';
  return 'old';
}
